<script>
  import Main from '../components/Main.svelte';
  export let params = false;
  console.log(params);
</script>

<Main {params}/>
